import { render, staticRenderFns } from "./BigImgCarousel.vue?vue&type=template&id=2c34fd94&scoped=true&"
import script from "./BigImgCarousel.vue?vue&type=script&lang=js&"
export * from "./BigImgCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BigImgCarousel.vue?vue&type=style&index=0&id=2c34fd94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34fd94",
  null
  
)

export default component.exports